import {SellpiaDom as _} from "./SellpiaDom";
import {StockViewBase} from "./StockViewBase";

export class StockViewMobile extends StockViewBase {
    constructor(props) {
        super(props);
    }

    createLayout({options, last_update, makeshop_product}) {
        let container = _.div(['layer-pop']);
        let body;
        this.shadow = _.div();
        this.shadow.style(
            "position: absolute;" +
            "top:0px;" +
            "left:0px;" +
            "width:100%" +
            "height:100%"
        );

        let style = this.writeStyle(style);

        if (options.find(option => option.pos) !== undefined) {
            body = this.createBodyPos(options, this.getOptionHeader(makeshop_product.option_category));
        } else {
            body = this.createBody(options, this.getOptionHeader(makeshop_product.option_category));
        }

        let close_button = (new _('a', 'l-close layer-close'));
        close_button.dom.addEventListener("click", () => {
            this.closeLayout();
        });

        this.main = _.div().add(_.div('l-stock-comm').add(_.div('layer').add(container.add([
            style, close_button,
            _.div("l-hd").text("재고현황"),
            _.div("l-tit").adds([
                _.strong("실시간 재고현황 보기"),
                last_update ? _.span("업데이트 날자 : "+last_update, "update") : false,
            ]), body
        ]))));
        _.attachBody(this.main, this.shadow);
    }

    createBody(options, headers) {
        let option_headers = headers;
        return _.div("l-cont").adds([
            _.table().attrs({'border': "0", 'summary': ""}).add([
                (new _("caption")),
                (new _("colgroup")).add(option_headers.map((header) => {
                    return (new _("col")).attrs({"width": (100 / (option_headers.length + 1)).toString() + "%"});
                })).add((new _("col")).attrs({"width": "*"})),
                (new _("thead")).add(
                    _.tr().add(
                        option_headers.map(option_header => {
                            return _.th_c(_.txt_c(option_header.title));
                        })
                    ).add(_.th_c(_.txt_c('재고현황')))
                ),
                (new _("tbody")).add(
                    options.map(option => {
                        return _.tr().add(
                            option.title.map(item => {
                                let td = _.td().add(_.txt_c(item.title));
                                if (item.row > 1) {
                                    td.attrs({'rowspan': item.row});
                                }
                                return td;
                            })
                        ).add(
                            _.td().add(this.getStatusDom(option)) // 재고현황
                        );
                    })
                )
            ]),
            this.createfoot()
        ])
    }

    createBodyPos(options, headers) {
        let option_headers = headers;
        return _.div("l-cont").add(_.div("l-tbl-wrap").adds([
            _.table().attrs({'border': "0", 'summary': ""}).add([
                (new _("caption")),
                // (new _("colgroup")).add(option_headers.map((header) => {
                //     return (new _("col")).attrs({"width": 540 / (option_headers.length + 1)});
                // })).add([
                //     (new _("col")).attrs({"width": "*"}),
                //     (new _("col")).attrs({"width": 80}),
                //     (new _("col")).attrs({"width": 90})
                // ]),
                (new _("thead")).add([
                        _.tr().add([
                            _.th_c(_.txt_c("온라인")).attrs({"colspan": option_headers.length + 1}).addClass("line-right-gray line-btm-gray"),
                            _.th_c(_.txt_c("오프라인")).attrs({"colspan": 2}).addClass("line-btm-gray")
                        ]),
                        _.tr().add(
                            option_headers.map(option_header => {
                                return _.th_c(_.txt_c(option_header.title));
                            })
                        ).add([
                            _.th_c(_.txt_c('재고현황')).addClass("line-right-gray"),
                            _.th_c(_.txt_c('오프라인')).addClass("line-right-gray"),
                            _.th_c(_.txt_c('매장재고')),
                        ])
                    ]
                ),
                (new _("tbody")).add(
                    options.map(option => {
                        return _.tr().add(
                            option.title.map(item => {
                                let td = _.td().add(_.txt_c(item.title));
                                if (item.row > 1) {
                                    td.attrs({'rowspan': item.row});
                                }
                                return td;
                            })
                        ).add(((option) => {
                                let stock_status = _.td("line-right-gray").add(this.getStatusDom(option)); // 재고현황
                                if (option.pos_sell === true) {
                                    return [
                                        stock_status,
                                        _.td('line-right-gray').add(_.txt_c("구매가능", "s-order on")),
                                        _.td().add(_.txt_c(_.a("s-order-map on layer-open", "#layer-stock-map").text("매장확인").click((event) => {
                                            this.show_pos(option);
                                        }))),
                                    ]
                                } else if (option.pos_sell === false) {
                                    return [
                                        stock_status,
                                        _.td('line-right-gray').add(_.txt_c("구매불가", "s-order off")),
                                        _.td().add(_.txt_c(_.a("s-order-map off layer-open", "#layer-stock-map").text("매장확인"))),
                                    ]
                                } else if (option.pos_sell === null) {
                                    return [
                                        stock_status,
                                        _.td('line-right-gray').add(_.txt_c(" ")),
                                        _.td().add(_.txt_c(" ")),
                                    ]
                                }
                            })(option)
                        );
                    })
                )
            ]),
            this.createfoot()
        ]))
    }

    writeStyle() {
        return (new _('style')).html(`
<style type="text/css">
    .clearfix:before, .clearfix:after { content: " "; display: table; }
    .clearfix:after { clear: both; } .clearfix { *zoom: 1; }
    #stock-contents, #stock-contents *, #stock-contents *:before, #stock-contents *:after { -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; }
    #stock-contents { position: relative; margin: 0 auto; overflow: hidden; }
    #stock-contents .stock-btns { text-align:center; }
    #stock-contents .stock-btns a { display:block; height:32px; line-height:29px; border:1px solid #ccc; font-family:'Malgun Gothic'; font-size:12px; color:#000; text-align:center; background:#fff; text-decoration:none; letter-spacing:-1px; }
    #stock-contents .stock-btns a:first-child { margin-bottom:6px; }

        /* 레이어 */
    .l-stock-comm .layer { position:fixed; top:0; left:0; width:100%; min-height:100%; background:rgba(0,0,0,0.75); }
    .l-stock-comm .layer .layer-pop { overflow-y:auto; position:absolute; top:0; left:0; width:100%; height:100%; background:#fff; font-family:'Malgun Gothic'; font-size:11px; }
    .l-stock-comm .layer .layer-pop .l-close { position:absolute; top:0; right:0; display:inline-block; width:41px; height:41px; top:0; right:0; background:url('https://sellpia-product.makeshop.co.kr/publish/img/btn_h15_close.gif') no-repeat center center; }
    .l-stock-comm .layer .layer-pop .l-hd { height:42px; line-height:39px; border-bottom:1px solid #ccc; font-size:14px; text-align:center; }
    .l-stock-comm .layer .layer-pop .l-tit { padding:20px 18px 15px; }
    .l-stock-comm .layer .layer-pop .l-tit strong { margin-right:7px; font-weight:bold; color:#000; font-size:22px; letter-spacing:-2.5px; vertical-align:middle; }
    .l-stock-comm .layer .layer-pop .l-tit span { display:inline-block; color:#999; vertical-align:middle; }
    .l-stock-comm .layer .layer-pop .l-tit span.update { padding-left:17px; margin-top:10px; background:url('https://sellpia-product.makeshop.co.kr/publish/img/ico_h26_clock.gif') no-repeat 0 2px; background-size:13px 13px; }
    .l-stock-comm .layer .layer-pop .l-cont { padding:0 18px; }
    .l-stock-comm .layer .layer-pop .l-cont table { width:100%; border-collapse:collapse; border-spacing:0; border-bottom:1px solid #000; }
    .l-stock-comm .layer .layer-pop .l-cont table th,
    .l-stock-comm .layer .layer-pop .l-cont table td { font-family: 'Malgun Gothic'; font-size:11px; letter-spacing:-0.5px; color:#000; word-break:break-all; }
    .l-stock-comm .layer .layer-pop .l-cont table th { border-top:1px solid #000; border-bottom:1px solid #ccc; background:#f6f6f6; font-weight:normal; }
    .l-stock-comm .layer .layer-pop .l-cont table td { border-top:1px solid #ccc; }
    .l-stock-comm .layer .layer-pop .l-cont table .line-right-gray { border-right:1px solid #ccc; }
    .l-stock-comm .layer .layer-pop .l-cont table th .txt-c,
    .l-stock-comm .layer .layer-pop .l-cont table td .txt-c { padding:5px 0 8px; text-align:center; }
    .l-stock-comm .layer .layer-pop .l-cont table td .txt-c img { width:33px; height:33px; }
    .l-stock-comm .layer .layer-pop .l-cont table td .fc-red { color:#ff3b3b; }
    .l-stock-comm .layer .layer-pop .l-cont table td .btn-stock-alarm { display:inline-block; height:15px; line-height:13px; padding:0 5px; margin-top:3px; border:1px solid #999; border-radius:20px; font-family:'Malgun Gothic'; color:#fff; font-size:10px; text-align:center; letter-spacing:-1px;  text-decoration:none; background:#999; }
    .l-stock-comm .layer .layer-pop .l-cont table td .s-order.on { color:#000; }
    .l-stock-comm .layer .layer-pop .l-cont table td .s-order.off { color:#e5e5e5; }
    .l-stock-comm .layer .layer-pop .l-cont table td .s-order-map { padding-right:8px; font-weight:bold; text-decoration:none; }
    .l-stock-comm .layer .layer-pop .l-cont table td .s-order-map.on { color:#4171bf; background:url('https://sellpia-product.makeshop.co.kr/publish/img/bull_h5_arr_on.gif') no-repeat right 7px; }
    .l-stock-comm .layer .layer-pop .l-cont table td .s-order-map.off { color:#cfdbef; background:url('https://sellpia-product.makeshop.co.kr/publish/img/bull_h5_arr_off.gif') no-repeat right 7px; }
    .l-stock-comm .layer .layer-pop .l-cont .l-txt { padding:5px 0 30px; margin:0; }
    .l-stock-comm .layer .layer-pop .l-cont .l-txt li { margin-top:5px; padding-left:6px; text-indent:-6px; color:#676767; line-height:18px; letter-spacing:-1px; list-style:none; }
    .l-stock-comm .layer .layer-pop .l-cont .l-txt li strong { color:#241c1a; }

    /* 오프라인 매장 재고 레이어 */
    #layer-stock-map .layer .layer-pop { top:70px; left:50%; width:90%; height:auto; margin-left:-45%; }
    #layer-stock-map .layer .layer-pop .l-close { width:45px; height:55px; background:url('https://sellpia-product.makeshop.co.kr/publish/img/btn_h27_close.gif') no-repeat center center; background-size:14px 14px; }
    #layer-stock-map .layer .layer-pop .l-tit { padding:15px 15px 0; }
    #layer-stock-map .layer .layer-pop .l-tit strong { font-size:16px; }
    #layer-stock-map .layer .layer-pop .l-tit span { display:block; margin-top:3px; letter-spacing:-1px; }
    #layer-stock-map .layer .layer-pop .l-prd { position:relative; min-height:40px; margin:15px; padding:10px 10px 10px 60px; border:1px solid #ccc; }
    #layer-stock-map .layer .layer-pop .l-prd > img { position:absolute; top:10px; left:10px; width:40px; height:40px; }
    #layer-stock-map .layer .layer-pop .l-prd .prd-name { padding:3px 0 2px; letter-spacing:-1px; }
    #layer-stock-map .layer .layer-pop .l-addr { min-height:17px; margin:0 15px 10px; padding-left:15px; background:url('https://sellpia-product.makeshop.co.kr/publish/img/ico_h14_map.gif') no-repeat 0 center; background-size:9px 13px; }
    #layer-stock-map .layer .layer-pop .l-addr .btn-sel-addr { display:inline-block; height:15px; line-height:13px; padding:0 5px; border:1px solid #999; border-radius:20px; font-family:'Malgun Gothic'; color:#fff; font-size:10px; text-align:center; letter-spacing:-1px;  text-decoration:none; background:#999; }
    #layer-stock-map .layer .layer-pop .l-cont { padding:0 15px 25px; }
    #layer-stock-map .layer .layer-pop .l-cont table { border-bottom:none; border-top:1px solid #000; }
    #layer-stock-map .layer .layer-pop .l-cont table th,
    #layer-stock-map .layer .layer-pop .l-cont table td { border-top:none; border-bottom:1px solid #ccc; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l { padding:0 8px; text-align:left; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l dl dt { font-weight:bold; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l dl dt span { font-weight:normal; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l dl dd { margin:0; font-weight:bold; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l dl dd span.line { display:inline-block; padding:0 10px; color:#ccc; }
    #layer-stock-map .layer .layer-pop .l-cont table td .txt-l dl dd.addr { padding-bottom:5px; color:#666; font-size:11px; font-weight:normal; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order.on { color:#ff3b3b; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order.off { color:#000; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy { display:inline-block; width:48%; height:30px; line-height:27px; margin-top:12px; font-weight:normal; text-decoration:none; font-size:11px; text-align:center; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy:first-child { margin-right:2px; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy.on.delivery { color:#000; background:#fff; border:1px solid #000; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy.on.shop { color:#fff; background:#000; border:1px solid #000; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy.off.delivery { color:#bfbfbf; background:#fff; border:1px solid #bfbfbf; }
    #layer-stock-map .layer .layer-pop .l-cont table td .s-order-buy.off.shop { color:#fff; background:#bfbfbf; border:1px solid #bfbfbf; }

    /* 지역선택 레이어 */
    #layer-stock-addr .layer .layer-pop { top:150px; left:50%; width:70%; height:auto; margin-left:-35%; }
    #layer-stock-addr .layer .layer-pop .l-close { width:45px; height:55px; background:url('https://sellpia-product.makeshop.co.kr/publish/img/btn_h27_close.gif') no-repeat center center; background-size:14px 14px; }
    #layer-stock-addr .layer .layer-pop .l-tit { padding:15px 15px 7px; }
    #layer-stock-addr .layer .layer-pop .l-tit strong { font-size:16px; }
    #layer-stock-addr .layer .layer-pop .l-cont { padding:0 15px 20px; }
    #layer-stock-addr .layer .layer-pop .l-cont ul { padding:0; margin:0; }
    #layer-stock-addr .layer .layer-pop .l-cont ul li { padding:9px 10px; margin:6px 0; border:1px solid #ccc; list-style:none; text-align:center; }
    #layer-stock-addr .layer .layer-pop .l-cont ul li.on { border:1px solid #000; font-weight:bold; }
    #layer-stock-addr .layer .layer-pop .l-cont ul li label { clear:both; display:block; height:16px; line-height:13px; }
    #layer-stock-addr .layer .layer-pop .l-cont ul li .input-chk { float:left; width:16px; height:16px; padding:0; margin:0; vertical-align:top; }
    #layer-stock-addr .layer .layer-pop .l-cont .btn-confirm { padding-top:8px; text-align:center; }
    #layer-stock-addr .layer .layer-pop .l-cont .btn-confirm a { display:inline-block; height:36px; line-height:33px; padding:0 38px; color:#fff; font-size:11px; background:#000; text-decoration:none; }
</style>
`)
    }
}
